<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><em>To the glory and honor<br/>of our Lord Jesus Christ</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310334965_epub_ded_r1.vue?76ec7727